import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { defaultPathForRole } from "../config/navConfig";
import { pathAllowedByRights } from "../config/accessRights";
import { useAccessRights } from "../context/AccessRightsContext";

export default function ProtectedRoute({ children, roles }) {
    const { user, loading } = useAuth();
    const rights = useAccessRights();
    const location = useLocation();

    if (loading || !rights.loaded) return null;
    if (!user) return <Navigate to="/" replace />;

    // Правка №58: при включённых правах «Доступов» страница открыта по праву, роль ERP не учитывается.
    const byRights = pathAllowedByRights(location.pathname);
    if (byRights !== null) {
        if (byRights) return children;
        const home = defaultPathForRole(user.role);
        if (home && home !== location.pathname && home !== "/unauthorized") return <Navigate to={home} replace />;
        return <Navigate to="/unauthorized" replace />;
    }

    if (roles && Array.isArray(roles) && roles.length > 0) {
        if (!user.role || !roles.includes(user.role)) {
            const home = defaultPathForRole(user.role);
            if (home && home !== location.pathname && home !== "/unauthorized") {
                return <Navigate to={home} replace />;
            }
            return <Navigate to="/unauthorized" replace />;
        }
    }

    return children;
}